import { ChargeStatus } from "@/primary-models";

export const FINALISED_CHARGE_STATUS = [
  ChargeStatus.FAILED,
  ChargeStatus.PROCESSED,
  ChargeStatus.CANCELLED,
] as const;

export type TFinalisedChargeStatus = typeof FINALISED_CHARGE_STATUS[number];

export type TNonFinalChargeStatus = Exclude<ChargeStatus, TFinalisedChargeStatus>;

export const IS_FINALISED_CHARGE_STATUS: Record<TFinalisedChargeStatus, true>
& Record<TNonFinalChargeStatus, false> = {
  [ChargeStatus.QUEUED]: false,
  [ChargeStatus.CHARGING]: false,
  [ChargeStatus.NEEDS_REGENERATION]: false,
  [ChargeStatus.PROCESSED]: true,
  [ChargeStatus.FAILED]: true,
  [ChargeStatus.CANCELLED]: true,
};

export function isFinalisedChargeStatus(
  toCheck: string | null | undefined,
): toCheck is TFinalisedChargeStatus {
  return !!toCheck && (IS_FINALISED_CHARGE_STATUS as Partial<Record<string, boolean>>)[toCheck] === true;
}

export function isNonFinalChargeStatus(
  toCheck: string | null | undefined,
): toCheck is TNonFinalChargeStatus {
  return !!toCheck && (IS_FINALISED_CHARGE_STATUS as Partial<Record<string, boolean>>)[toCheck] === false;
}

export const NON_FINAL_CHARGE_STATUS: TNonFinalChargeStatus[] =
  Object.values(ChargeStatus).filter(isNonFinalChargeStatus);
